import { render, staticRenderFns } from "./doctorTemplateH5.vue?vue&type=template&id=e94921fc&scoped=true&"
import script from "./doctorTemplateH5.vue?vue&type=script&lang=ts&"
export * from "./doctorTemplateH5.vue?vue&type=script&lang=ts&"
import style0 from "./doctorTemplateH5.vue?vue&type=style&index=0&id=e94921fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94921fc",
  null
  
)

export default component.exports